export default "/images/vendor/chocolat/dist/left.png?b771e7e5691ca90493c6c79105152907";